import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import { motion } from 'framer-motion';
import * as emailjs from 'emailjs-com';
import { useToasts } from 'react-toast-notifications';

function Contact({ windowHeight }) {
  const { addToast } = useToasts();

  const nameRef = useRef(null);
  const emailRef = useRef(null);
  const subjectRef = useRef(null);
  const messageRef = useRef(null);
  const submitRef = useRef(null);
  const submitDivRef = useRef(null);
  const [submitHover, setSubmitHover] = useState(false);

  const service_id = 'service_n66svtr';
  const template_id = 'template_ort3gtq';
  emailjs.init('user_5eaDA2F5J2T80KiLkAvlC');

  mapboxgl.accessToken =
    'pk.eyJ1IjoicGhheHoxMCIsImEiOiJja3EzbzZlbnowbGNtMnhvYzh1OW5sZWZtIn0.06Qj0TcqjP0QBRieVUgL7w';

  const mapContainerRef = useRef(null);

  const [lng, setLng] = useState(120.4166);
  const [lat, setLat] = useState(16.3493);
  const [zoom, setZoom] = useState(10);

  useEffect(() => {
    const map = new mapboxgl.Map({
      container: mapContainerRef.current,
      style: 'mapbox://styles/mapbox/dark-v10',
      center: [lng, lat],
      zoom: zoom,
    });

    const marker = new mapboxgl.Marker().setLngLat([lng, lat]).addTo(map);

    // Add navigation control (the +/- zoom buttons)
    map.addControl(new mapboxgl.NavigationControl(), 'bottom-right');

    map.on('move', () => {
      setLng(map.getCenter().lng.toFixed(4));
      setLat(map.getCenter().lat.toFixed(4));
      setZoom(map.getZoom().toFixed(2));
    });

    // Clean up on unmount
    return () => map.remove();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const mapVariant = {
    initial: { opacity: 0, scale: 1.1 },
    animate: { opacity: 1, scale: 1 },
  };

  const submit = (e) => {
    e.preventDefault();
    let error = 0;

    if (emailRef.current.value === '') {
      emailRef.current.style.borderBottomColor = 'red';
      error += 1;
    } else {
      if (!/.+@.+\.[A-Za-z]+$/.test(emailRef.current.value)) {
        addToast('Invalid Email', { appearance: 'error' });
        return;
      }
      emailRef.current.style.borderBottomColor = 'black';
    }
    if (nameRef.current.value === '') {
      nameRef.current.style.borderBottomColor = 'red';
      error += 1;
    } else nameRef.current.style.borderBottomColor = 'black';
    if (subjectRef.current.value === '') {
      subjectRef.current.style.borderBottomColor = 'red';
      error += 1;
    } else subjectRef.current.style.borderBottomColor = 'black';
    if (messageRef.current.value === '') {
      messageRef.current.style.borderBottomColor = 'red';
      error += 1;
    } else messageRef.current.style.borderBottomColor = 'black';

    if (error > 0) {
      addToast('Please fill all fields', { appearance: 'error' });
      return;
    }

    toggleForm(true, '#14947c');

    var email_template = {
      message: messageRef.current.value,
      sender_name: nameRef.current.value,
      sender_email: emailRef.current.value,
      topic: subjectRef.current.value,
    };

    emailjs
      .send(service_id, template_id, email_template)
      .then((res) => {
        messageRef.current.value = '';
        nameRef.current.value = '';
        emailRef.current.value = '';
        subjectRef.current.value = '';

        addToast('Email Sent', { appearance: 'success' }, () =>
          toggleForm(false, 'black')
        );
      })
      .catch((err) => addToast('Email not Sent', { appearance: 'error' }));

    console.log(email_template);
  };

  const toggleForm = (bool, bgColor) => {
    console.log(submitDivRef.current.style);
    messageRef.current.disabled = bool;
    nameRef.current.disabled = bool;
    emailRef.current.disabled = bool;
    subjectRef.current.disabled = bool;
    submitDivRef.current.style.backgroundColor = bgColor;
    submitRef.current.disabled = bool;
  };

  const contactVariant = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.5,
        duration: 1,
      },
    },
  };

  const contactChild1Variant = {
    hidden: { opacity: 0, x: 100 },
    show: { opacity: 1, x: 0, transition: { duration: 1 } },
  };
  const contactChild2Variant = {
    hidden: { opacity: 0, x: -100 },
    show: { opacity: 1, x: 0, transition: { duration: 1 } },
  };

  const submitBtnVariant = {
    animate: { width: '100%' },
    initial: { width: '0%' },
  };

  return (
    <Container height={windowHeight}>
      <div className='grid lg:flex space-y-20 lg:space-y-0 max-w-screen-2xl'>
        <motion.div
          className='flex-grow p-4 pt-20 md:pt-20 md:p-10 lg:p-20 lg:pt-12'
          variants={contactVariant}
          animate='show'
          initial='hidden'
        >
          <div className='text-blue-150 col-span-full'>
            <motion.h1
              variants={contactChild1Variant}
              className='text-6xl font-bold'
            >
              Let's make something great!
            </motion.h1>
            <motion.p
              className='text-white my-5'
              variants={contactChild2Variant}
            >
              I’m interested in freelance opportunities. if you have request or
              question, don’t hesitate to contact me below.
            </motion.p>
          </div>
          <motion.form
            variants={contactChild1Variant}
            onSubmit={submit}
            className='grid grid-cols-2 gap-y-5 gap-x-3 max-h-full'
          >
            <TextArea
              ref={nameRef}
              type='text'
              placeholder='Name'
              disabled={false}
            />
            <TextArea
              ref={emailRef}
              type='text'
              placeholder='Email'
              disabled={false}
            />
            <TextArea
              ref={subjectRef}
              className='col-span-full'
              type='text'
              placeholder='Subject'
              disabled={false}
            />
            <textarea
              ref={messageRef}
              className='col-span-full p-2 h-32 border-black border-b-2 outline-none bg-gray-500'
              placeholder='Message'
              cols='10'
              rows='10'
              disabled={false}
            ></textarea>
            {/* submit button */}
            <input ref={submitRef} hidden type='submit' disabled={false} />
            <div
              onMouseEnter={() => setSubmitHover(true)}
              onMouseLeave={() => setSubmitHover(false)}
              ref={submitDivRef}
              className='overflow-hidden relative flex items-center justify-center rounded-sm h-10 col-span-full w-full text-white font-bold tracking-widest border-blue-150 border-2 cursor-pointer bg-black'
              onClick={() => submitRef.current.click()}
            >
              <motion.div
                variants={submitBtnVariant}
                initial='inital'
                animate={submitHover ? 'animate' : 'initial'}
                transition={{ duration: 1, ease: 'easeInOut' }}
                className='absolute w-full h-full top-0 left-0 z-0 bg-blue-150'
              />
              <p className='z-10'>Submit</p>
            </div>
          </motion.form>
        </motion.div>
        <motion.div
          className='relative min-w-screen md:min-w-[50vw] min-h-[50vh] md:min-h-screen z-0'
          ref={mapContainerRef}
          variants={mapVariant}
          initial='initial'
          animate='animate'
          transition={{ duration: 0.5, delay: 0.5 }}
        >
          <div className='absolute top-2 left-2 md:top-4 md:left-4 h-40 w-60 bg-black bg-opacity-50 z-10 rounded-sm p-5 text-base tracking-wider opacity-40 hover:opacity-80'>
            <p>John Paolo Bautista</p>
            <p>Tubao, La Union</p>
            <p>Philippines, 2509</p>
            <br />
            <p>(+63) 927 254 9755</p>
          </div>
        </motion.div>
      </div>
    </Container>
  );
}

export default Contact;

const Container = styled.div`
  display: grid;
  place-items: center;
  display: relative;
  height: ${(props) => props.height}px;
  width: 100vw;
  background-color: black;
  color: white;
  overflow-y: scroll;
  overflow-x: hidden;
`;

const TextArea = styled.input`
  outline: none;
  padding: 5px;
  height: 40px;
  border-bottom: 2px solid black;
  background-color: rgba(107, 114, 128, 1);
`;
